import React , {useEffect,useState,useRef} from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getYear,getMonth } from "date-fns";
import { useContext } from 'react'
import AuthContext from './AuthContext';
import Axios from 'axios';
import Modals from './Modals';
import Modals_Load from './Modals_Load';
import { useHistory } from "react-router-dom";
import { parse } from 'date-fns';


const FrmProfile_th = () => {

  const history = useHistory();
  const modalsRef = useRef(null);
  const modalsRef_load = useRef(null);
  
  const {gclang} = useContext(AuthContext);
  const {gnuserid} = useContext(AuthContext);
  const {gcusername} =  useContext(AuthContext);
  const {token,settoken} = useContext(AuthContext);

  const [Qeditprofilearr,setQeditprofilearr] = useState([]);        
  const [Qeditprofile,setQeditprofile] = useState({        
    lang:gclang,
    ID_Number:gnuserid,
    LeadName:'',
    LeadNameEng:'',
    First_Name_Thai:'',
    Last_Name_Thai:'',
    First_Name_Eng:'',
    Last_Name_Eng:'',
    Birth_Date:'',    
    Sex:'',
    ID_Issue_Place:'',
    ID_Issue_Place_Eng:'',
    ID_Expiry_Date:'',    
    Email:'',  
    Address1:'',
    Address1_Eng:'',
    Telephone:'',
    MobilePhone:'',    
    Question:'',        
    AnswerQuestion:'',
    CreateAt:'',
    LastUpdate:''                  
  });

  const fn_range = (start, end, step = 1) => {
    const output = [];
    for (let i = start; i < end; i += step) {
      output.push(i);
    }
    return output;
  };

  const [startDate, setStartDate] = useState(new Date());
  const [expiredDate, setExpiredDate] = useState(new Date());
  //const [startDate, setStartDate] = useState('');
  //const [expiredDate, setExpiredDate] = useState('');
  //const years = fn_range(1750, getYear(new Date()) + 1, 1);  
  const years = fn_range(1750, getYear(new Date()) + 50, 1);  
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const renderCustomHeader = (date, changeYear, changeMonth) => (
    <div
      style={{
        margin: 10,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <select
        value={getYear(date)}
        onChange={({ target: { value } }) => changeYear(Number(value))}
      >
        {years.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      <select
        value={months[getMonth(date)]}
        onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
      >
        {months.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
  
  useEffect(() => {
 
    async function fetchData() { 
      
      modalsRef_load.current.fnshow();  
      //const response = await Axios.post('/insertexamreuse',addFormData,{                       
      //const response = await Axios.post('/qprofile',{'QEdittemplate':QEdittemplate,'QEdittemplatearr':QEdittemplatearr},{                     
      const response = await Axios.post('/qprofile',Qeditprofile,{                       
          'withCredentials': false,     
          headers:{
              "x-access-token": token,              
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0',        
            }});
          if(response.data.result === '0' || response.data.result === '-1') {            
              modalsRef.current.fnshow('ข้อความเตือน',response.data.msg,false,true);
              ////history.push('/login');
  
          }
          else{    
              
              if(response.data.length > 0){   
                  modalsRef_load.current.fnclose();            
                  let output = response.data;                                                                                                                               
                  
                  setQeditprofilearr(output); 
                  
                  setQeditprofile({
                    ...output[0] // Spread all key-value pairs from the first object in Qeditprofilearr
                  }); 

                  setQeditprofile((p) => ({...p,lang:gclang}));                       

                  const birthDate = new Date(output[0].Birth_Date);                   
                  setStartDate(birthDate);
                  
                  const ID_Expiry_Date = new Date(output[0].ID_Expiry_Date);                   
                  setExpiredDate(ID_Expiry_Date);
                  
                               
              }
              else{                                
                
                setQeditprofile((p) => ({...p,lang:gclang,ID_Number:gnuserid,LeadName:'',First_Name_Thai:'',Last_Name_Thai:'',First_Name_Eng:'',Last_Name_Eng:'',Birth_Date:'',Sex:'',ID_Issue_Place:'',ID_Issue_Place_Eng:'',ID_Expiry_Date:'',Email:'',  Address1:'',Address1_Eng:'',Telephone:'',MobilePhone:'',Question:'',AnswerQuestion:'',CreateAt:'',LastUpdate:''}));                       
                 
              }          
          }                                                                 
  }
           
    fetchData();      
    

  }, [token]); 

  // ตรวจสอบค่า 
  console.log(Qeditprofile); 
  console.log(Qeditprofile.Birth_Date);

  const handleAddChange = async (e) =>{
    e.preventDefault();
          
    const fieldName = e.target.getAttribute('name');
    const fieldValue = e.target.value;
    
    const newQeditprofile = {...Qeditprofile }; 
    newQeditprofile[fieldName] = fieldValue;
    
    setQeditprofile(newQeditprofile);
              
  }


  const handleselsexchange = async (e) =>{
    
    e.preventDefault();  
    
    const newQeditprofile = {...Qeditprofile }; 
    newQeditprofile["Sex"] = e.target.value;
    setQeditprofile(newQeditprofile);
   
  }


  const handleselID_Issue_Placechange = async (e) =>{
    
    e.preventDefault();  
    
    const newQeditprofile = {...Qeditprofile }; 
    newQeditprofile["ID_Issue_Place"] = e.target.value;
    setQeditprofile(newQeditprofile);
   
  }

  

  const handleselleadnamechange = async (e) =>{
    
    e.preventDefault();  
    
    const newQeditprofile = {...Qeditprofile }; 
    newQeditprofile["LeadName"] = e.target.value;
    setQeditprofile(newQeditprofile);
   
  }


  const fncallback = (e,iserror) => {
    e.preventDefault(); 
    if(iserror === true)
    {
      modalsRef.current.fnclose();                                    
      history.push('/login');
    }
    else{
      modalsRef.current.fnclose();        
      //modalsRef.current.fnshow('Output','กรุณากรอกข้อมูลก่อนครับ',false,false,"1");                             
    }
    
  }
  


  const handleUpdateChange2 = (date) => {
    if (date) {
      const clonedDate = new Date(date.getTime());
  
      // Convert the date to UTC and format it as 'YYYY-MM-DD' for consistency
      const formattedBirthDate = new Date(Date.UTC(
        clonedDate.getFullYear(),
        clonedDate.getMonth(),
        clonedDate.getDate()
      ));
  
      // Set cloned date for DatePicker
      setStartDate(formattedBirthDate);
  
      // Directly set the formatted date in the state (no need to parse it again)
      setQeditprofile((prev) => ({
        ...prev,
        Birth_Date: formattedBirthDate.toISOString(), // Send the UTC date as an ISO string
      }));
    }
  };

  const handleUpdateChange2_old = (date) => {
    if (date) {
      const clonedDate = new Date(date.getTime());
      
      const formattedBirthDate = new Date(Date.UTC(
        clonedDate.getFullYear(),
        clonedDate.getMonth(),
        clonedDate.getDate()
      )).toLocaleDateString("en-GB");
  
      setStartDate(clonedDate); // Set cloned date for DatePicker
         
      const birthDateObject = parse(formattedBirthDate, 'dd/MM/yyyy', new Date());
            
      setQeditprofile((prev) => ({
        ...prev,
        //Birth_Date: formattedBirthDate,
        Birth_Date: birthDateObject,
      }));
    }
  };


  const handleUpdateChange3 = (date) => {
    if (date) {
      const clonedDate = new Date(date.getTime());  
      // Convert the date to UTC and format it as 'YYYY-MM-DD' for consistency
      const formattedExpiredDate = new Date(Date.UTC(
        clonedDate.getFullYear(),
        clonedDate.getMonth(),
        clonedDate.getDate()
      ));
  
      // Set cloned date for DatePicker
      setExpiredDate(formattedExpiredDate); // Set cloned date for DatePicker
  
      // Directly set the formatted date in the state (no need to parse it again)
      setQeditprofile((prev) => ({
        ...prev,
        ID_Expiry_Date: formattedExpiredDate.toISOString(), // Send the UTC date as an ISO string
      }));
    }
      
  };

  const handleUpdateChange3_old = (date) => {
    
    if (date) {
      const clonedDate = new Date(date.getTime());

      const formattedExpiredDate = new Date(Date.UTC(
        clonedDate.getFullYear(),
        clonedDate.getMonth(),
        clonedDate.getDate()
      )).toLocaleDateString("en-GB");
  
      setExpiredDate(clonedDate); // Set cloned date for DatePicker
   
      const ExpiredDateObject = parse(formattedExpiredDate, 'dd/MM/yyyy', new Date());

      setQeditprofile((prev) => ({
        ...prev,
        //ID_Expiry_Date: formattedExpiredDate,
        ID_Expiry_Date: ExpiredDateObject,
      }));
    }
  };

  
const allowEnglishOnly = (e) => {
  const char = e.key;

  if (
    char === 'Backspace' ||
    char === 'Delete' ||
    char === 'ArrowLeft' ||
    char === 'ArrowRight' ||
    char === 'Tab'
  ) {
    return;
  }

  const engRegex = /^[A-Za-z\s]$/;

  if (!engRegex.test(char)) {
    e.preventDefault();
  }
};

  
const allowThaiOnly = (e) => {
  const char = e.key;

  // อนุญาตปุ่มควบคุม
  if (
    char === 'Backspace' ||
    char === 'Delete' ||
    char === 'ArrowLeft' ||
    char === 'ArrowRight' ||
    char === 'Tab'
  ) {
    return;
  }

  // Regex ภาษาไทย
  const thaiRegex = /^[\u0E00-\u0E7F]$/;

  if (!thaiRegex.test(char)) {
    e.preventDefault();
  }
};


  const handleUpdateChange = async (e) =>{
    //tidtee
    //1234567890121
    e.preventDefault();  
    
    // trim() กันกรณีใส่แต่ space
    if (
      !Qeditprofile.LeadName?.trim() ||
      !Qeditprofile.First_Name_Thai?.trim() ||
      !Qeditprofile.Last_Name_Thai?.trim() ||
      !Qeditprofile.First_Name_Eng?.trim() ||
      !Qeditprofile.Last_Name_Eng?.trim()
    ) {
      alert('กรุณากรอกข้อมูลตรง * ให้ครบถ้วน');
      return;
    }

    const thaiTextRegex = /^[\u0E00-\u0E7F\s]+$/;

    if (
      !thaiTextRegex.test(Qeditprofile.First_Name_Thai) ||
      !thaiTextRegex.test(Qeditprofile.Last_Name_Thai)
    ) {
      alert('ชื่อและนามสกุลภาษาไทย ต้องเป็นอักษรไทยเท่านั้น');
      return;
    }

      // 3. English only
    const engTextRegex = /^[A-Za-z\s]+$/;

    if (
      !engTextRegex.test(Qeditprofile.First_Name_Eng) ||
      !engTextRegex.test(Qeditprofile.Last_Name_Eng)
    ) {
      alert('ชื่อและนามสกุลภาษาอังกฤษ ต้องเป็นตัวอักษร A-Z เท่านั้น');
      return;
    }
    
    /*
    console.log(Qeditprofile.LeadName);
    console.log(Qeditprofile.First_Name_Thai);
    console.log(Qeditprofile.Last_Name_Thai);
    console.log(Qeditprofile.First_Name_Eng);
    console.log(Qeditprofile.Last_Name_Eng);
    */
    
    console.log(Qeditprofile); 
     

    
    const response = await Axios.post('/editprofile', Qeditprofile,{               
      'withCredentials': false,     
      headers:{
          "x-access-token": token,              
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',        
    }});
    let output = response.data; 
    //console.log(output);
    
    if(output[0].issuccess === 1){
      //alert(`${output[0].msg}`);  
      modalsRef.current.fnshow('Output',`${output[0].msg}`,false,false,"1");         
      
    }
    else{
      alert(`${output[0].msg}`);
    }


    

    /*
    if (startDate) {
      const formattedBirthDate = startDate.toLocaleDateString("en-GB"); // Format to dd/MM/yyyy
      console.log("Selected Birthdate:", formattedBirthDate); // Display the selected date
      
    } else {
      console.log("No date selected");
    }
    
    if (expiredDate) {
      const formattedExpiredDate = expiredDate.toLocaleDateString("en-GB"); // Format to dd/MM/yyyy
      console.log("Selected Expireddate:", formattedExpiredDate); // Display the selected date
      
    } else {
      console.log("No date selected");
    }
    
    */
    
              

  }

 

  return (
    <>
      <Modals_Load ref={modalsRef_load} />
      <Modals lctitle='' lcbody='' fullscreen='false' fncallback={fncallback} ref={modalsRef} />
      <br></br>
      <div class="container mt-5">
            <h4 class="text-center mb-4"><b>โปรไฟล์</b></h4>
            <form autocomplete="off" class="shadow p-4 rounded bg-light">
            <div className="mb-4 row">
              <label htmlFor="staticIDNumber" className="col-auto col-form-label text-primary"><b>เลขประจำตัวประชาชน:</b></label>
              <div className="col">
                <input 
                  type="text" 
                  readOnly 
                  className="form-control-plaintext" 
                  id="ID_Number" 
                  name="ID_Number" 
                  value={gnuserid} 
                />
              </div>
            </div>

            <div className="mb-4">
              <label htmlFor="staticPrefaceName" className="form-label"><b>คำนำหน้า <span style={{ color: 'red' }}>*</span></b></label>              
                  <select className="form-select" name="LeadName" id="LeadName"  value={Qeditprofile.LeadName} onChange={handleselleadnamechange}>         
                  <option value=''>Please Select</option>
                  <option value='นาย'>นาย</option>
                  <option value='นางสาว'>นางสาว</option>
                  <option value='นาง'>นาง</option>
                  </select>                                  
            </div>
      
        

            <div class="mb-4">         
              <label for="staticName" class="form-label"><b>ชื่อ <span style={{ color: 'red' }}>*</span></b></label>                    
              <input type="text" class="form-control" id="First_Name_Thai" name="First_Name_Thai" value={Qeditprofile.First_Name_Thai} onChange={handleAddChange} onKeyDown={allowThaiOnly} />              
            </div>                


         

            <div class="mb-4">
              <label for="staticLastName" class="form-label"><b>นามสกุล <span style={{ color: 'red' }}>*</span></b></label>              
              <input type="text" class="form-control" id="Last_Name_Thai" name ="Last_Name_Thai" value={Qeditprofile.Last_Name_Thai} onChange={handleAddChange} onKeyDown={allowThaiOnly} />
              
            </div>
     
            <div class="mb-4">
              <label for="staticname_eng" class="form-label"><b>ชื่อ (ภาษาอังกฤษ) <span style={{ color: 'red' }}>*</span></b></label>
              <input type="text" class="form-control" id="First_Name_Eng"name="First_Name_Eng" value={Qeditprofile.First_Name_Eng} onChange={handleAddChange} onKeyDown={allowEnglishOnly} />                            
            </div>
  
            <div class="mb-4">
              <label for="staticlastname_eng" class="form-label"><b>นามสกุล (ภาษาอังกฤษ) <span style={{ color: 'red' }}>*</span></b></label>
              <input type="text" class="form-control" id="Last_Name_Eng" name="Last_Name_Eng" value={Qeditprofile.Last_Name_Eng} onChange={handleAddChange} onKeyDown={allowEnglishOnly}/>
            </div>  

            <div class="mb-4">
              <label for="staticbirthdate" class="form-label"><b>วันเดือนปีเกิด (DD/MM/YYYY)</b>&nbsp;&nbsp;</label>                
                <DatePicker
                  renderCustomHeader={({ date, changeYear, changeMonth }) =>
                    renderCustomHeader(date, changeYear, changeMonth)
                  }
                  selected={startDate}
                  onChange={handleUpdateChange2}
                  dateFormat="dd/MM/yyyy"
                  id="Birth_Date"
                  name="Birth_Date"                
                />                          
            </div>

            <div class="mb-4">
              <label for="staticSex" class="form-label"><b>เพศ</b></label>        
              <select className="form-select" name="Sex" id="Sex" value={Qeditprofile.Sex} onChange={handleselsexchange} >         
              <option value=''>Please Select</option>
              <option value='M'>M</option>
              <option value='F'>F</option>              
              </select>            
            </div>


          <div class="mb-4">
            <label for="staticSex" class="form-label"><b>สถานที่ออกบัตร</b></label>           
            <select className="form-select" name="ID_Issue_Place" id="ID_Issue_Place" value={Qeditprofile.ID_Issue_Place} onChange={handleselID_Issue_Placechange} >         
            <option value=''>Please Select</option>
            <option value='กรุงเทพมหานคร'>กรุงเทพมหานคร</option>
            <option value='กระบี่'>กระบี่</option>              
            <option value='กาญจนบุรี'>กาญจนบุรี</option>              
            <option value='กาฬสินธุ์'>กาฬสินธุ์</option>              
            <option value='กำแพงเพชร'>กำแพงเพชร</option>              
            <option value='ขอนแก่น'>ขอนแก่น</option>              
            <option value='จันทบุรี'>จันทบุรี</option>              
            <option value='ฉะเชิงเทรา'>ฉะเชิงเทรา</option>              
            <option value='ชลบุรี'>ชลบุรี</option>              
            <option value='ชัยนาท'>ชัยนาท</option>              
            <option value='ชัยภูมิ'>ชัยภูมิ</option>              
            <option value='ชุมพร'>ชุมพร</option>              
            <option value='เชียงราย'>เชียงราย</option>              
            <option value='เชียงใหม่'>เชียงใหม่</option>              
            <option value='ตรัง'>ตรัง</option>              
            <option value='ตราด'>ตราด</option>              
            <option value='ตาก'>ตาก</option>              
            <option value='นครนายก'>นครนายก</option>              
            <option value='นครปฐม'>นครปฐม</option>              
            <option value='นครพนม'>นครพนม</option>              
            <option value='นครราชสีมา'>นครราชสีมา</option>              
            <option value='นครศรีธรรมราช'>นครศรีธรรมราช</option>              
            <option value='นครสวรรค์'>นครสวรรค์</option>              
            <option value='นนทบุรี'>นนทบุรี</option>              
            <option value='นราธิวาส'>นราธิวาส</option>              
            <option value='น่าน'>น่าน</option>              
            <option value='บึงกาฬ'>บึงกาฬ</option>              
            <option value='บุรีรัมย์'>บุรีรัมย์</option>              
            <option value='ปทุมธานี'>ปทุมธานี</option>              
            <option value='ประจวบคิรีขันธ์'>ประจวบคิรีขันธ์</option>              
            <option value='ปราจีนบุรี'>ปราจีนบุรี</option>              
            <option value='ปัตตานี'>ปัตตานี</option>              
            <option value='พระนครศรีอยุธยา'>พระนครศรีอยุธยา</option>              
            <option value='พะเยา'>พะเยา</option>              
            <option value='พังงา'>พังงา</option>              
            <option value='พัทลุง'>พัทลุง</option>              
            <option value='พิจิตร'>พิจิตร</option>              
            <option value='พิษณุโลก'>พิษณุโลก</option>              
            <option value='เพชรบุรี'>เพชรบุรี</option>              
            <option value='เพชรบูรณ์'>เพชรบูรณ์</option>              
            <option value='แพร่'>แพร่</option>              
            <option value='ภูเก็ต'>ภูเก็ต</option>              
            <option value='มหาสารคาม'>มหาสารคาม</option>              
            <option value='มุกดาหาร'>มุกดาหาร</option>              
            <option value='แม่ฮ่องสอน'>แม่ฮ่องสอน</option>              
            <option value='ยโสธร'>ยโสธร</option>              
            <option value='ยะลา'>ยะลา</option>              
            <option value='ร้อยเอ็ด'>ร้อยเอ็ด</option>              
            <option value='ระนอง'>ระนอง</option>              
            <option value='ระยอง'>ระยอง</option>              
            <option value='ราชบุรี'>ราชบุรี</option>              
            <option value='ลพบุรี'>ลพบุรี</option>              
            <option value='ลำปาง'>ลำปาง</option>              
            <option value='ลำพูน'>ลำพูน</option>              
            <option value='เลย'>เลย</option>              
            <option value='ศรีสะเกษ'>ศรีสะเกษ</option>              
            <option value='สกลนคร'>สกลนคร</option>              
            <option value='สงขลา'>สงขลา</option>              
            <option value='สตูล'>สตูล</option>              
            <option value='สมุทรปราการ'>สมุทรปราการ</option>              
            <option value='สมุทรสงคราม'>สมุทรสงคราม</option>              
            <option value='สมุทรสาคร'>สมุทรสาคร</option>              
            <option value='สระแก้ว'>สระแก้ว</option>              
            <option value='สระบุรี'>สระบุรี</option>              
            <option value='สิงห์บุรี'>สิงห์บุรี</option>              
            <option value='สุโขทัย'>สุโขทัย</option>              
            <option value='สุพรรณบุรี'>สุพรรณบุรี</option>              
            <option value='สุราษฎร์ธานี'>สุราษฎร์ธานี</option>              
            <option value='สุรินทร์'>สุรินทร์</option>              
            <option value='หนองคาย'>หนองคาย</option>              
            <option value='หนองบัวลำภู'>หนองบัวลำภู</option>              
            <option value='อ่างทอง'>อ่างทอง</option>              
            <option value='อำนาจเจริญ'>อำนาจเจริญ</option>              
            <option value='อุดรธานี'>อุดรธานี</option>              
            <option value='อุตรดิตถ์'>อุตรดิตถ์</option>              
            <option value='อุทัยธานี'>อุทัยธานี</option>              
            <option value='อุบลราชธานี'>อุบลราชธานี</option>                            
            </select>               
          </div>


          <div class="mb-4">
            <label for="staticExpireddate" class="form-label"><b>วันหมดอายุ (DD/MM/YYYY)</b>&nbsp;&nbsp;</label>             
              <DatePicker
                renderCustomHeader={({ date, changeYear, changeMonth }) =>
                  renderCustomHeader(date, changeYear, changeMonth)
                }
                selected={expiredDate}
                onChange={handleUpdateChange3}
                dateFormat="dd/MM/yyyy"
                id="ID_Expiry_Date"
                name="ID_Expiry_Date"
              />              
          </div> 

          <div class="mb-4">
              <label for="staticEmail" class="form-label"><b>อีเมล</b></label>              
              <input type="email" class="form-control" id="Email" name="Email" value={Qeditprofile.Email} onChange={handleAddChange} />                              
            </div>   

          <div class="mb-4">
            <label for="staticAddress" class="form-label"><b>ที่อยู่</b></label>
            <textarea class="form-control" id="Address1" name="Address1" rows="4" value={Qeditprofile.Address1} onChange={handleAddChange}></textarea>              
          </div>


          <div class="mb-4">
              <label for="statictelephone" class="form-label"><b>โทรศัพท์</b></label>
              <input type="text" class="form-control" id="Telephone" name="Telephone" value={Qeditprofile.Telephone} onChange={handleAddChange} />              
            </div>

            <div class="mb-4">
              <label for="staticmobilephone" class="form-label"><b>โทรศัพท์มือถือ</b></label>          
              <input type="text" class="form-control" id="MobilePhone" name="MobilePhone" value={Qeditprofile.MobilePhone} onChange={handleAddChange} />          
            </div>

          
            <div className="mb-4 row">
              <label htmlFor="staticCreateat" className="col-auto col-form-label"><b>ถูกสร้างขึ้นเมื่อ:</b></label>
              <div className="col">
                <input 
                  type="text" 
                  readOnly 
                  className="form-control-plaintext" 
                  id="CreateAt" 
                  name="CreateAt" 
                  value={Qeditprofile.CreateAt} 
                />
              </div>
            </div>
          
  
            <div className="mb-4 row">
              <label htmlFor="staticadjustdate" className="col-auto col-form-label"><b>ปรับปรุงครั้งสุดท้ายเมื่อ:</b></label>
              <div className="col">
                <input 
                  type="text" 
                  readOnly 
                  className="form-control-plaintext" 
                  id="LastUpdate" 
                  name="LastUpdate" 
                  value={Qeditprofile.LastUpdate} 
                />
              </div>
            </div>


            <div class="mb-4">
              <label for="staticquestionforsecurity" class="form-label"><b>คำถามความปลอดภัย</b></label>
              <input type="text" class="form-control" id="Question" name="Question"  value={Qeditprofile.Question} onChange={handleAddChange} />                            
            </div>

            <div class="mb-4">
              <label for="staticanswer" class="form-label"><b>คำตอบ</b></label>
              <input type="text" class="form-control" id="AnswerQuestion" name="AnswerQuestion"  value={Qeditprofile.AnswerQuestion} onChange={handleAddChange} />         
            </div>

            <div class="mb-4">          
              <button className='btn btn-primary w-100' onClick={handleUpdateChange}>ปรับปรุง</button>            
            </div>   
       
        </form>
      </div>
       
    </>
    )
}

export default FrmProfile_th